import $ from "jquery";

export default class Form {
    constructor() {
        let removeEmptyValue = (el) => {
            el.classList.remove('filled');
            el.value = '';
        }

        $('.form input, .form textarea').each((i, e) => {
            console.log()
            let current = e;
            let value = current.value;
            value.trim().length > 0 ? current.classList.add('filled') : removeEmptyValue(current);
        });

        $('.form input, .form textarea').blur((e) => {
            let current = e.currentTarget;
            let value = current.value;
            value.trim().length > 0 ? current.classList.add('filled') : removeEmptyValue(current);
        });

        this.appointmentForm = document.querySelector(('.f-form.appointment form'));
        this.hiddenFields = document.querySelectorAll('.f-form .field.hidden');
        this.toggleField = document.querySelectorAll('input[name="contactinfo"]');

        //!!this.appointmentForm && this.handleAppointmentForm();
    }

    handleAppointmentForm() {
        [...this.toggleField].map((item, index) => {
            item.addEventListener('click', e => {
               this.handleChange(e.target.value);
            })
        });
    }

    handleChange(value) {
        console.log('change');
        if(value === 'telefon') {
            [...this.hiddenFields].map(i => {
                i.classList.remove('hidden');
            })
        } else {
            [...this.hiddenFields].map(i => {
                i.classList.add('hidden');
                [...i.querySelectorAll('input')].map(item => {
                    item.classList.remove('filled');
                    if(item.type === 'checkbox') {
                    item.checked = false;
                    } else if (item.type === 'text') {
                        item.value = '';
                    }
                });
            })
        }
    }
}
